// Autogenerated locales - do not modify
/* tslint:disable quotemark variable-name */
export const BAZAAR_PLUS_PRICE_WITH_VAT_price = "%(price)s s DPH";
export const CHECK_YOUR_PLAN_STATE = "Skontroluj stav";
export const CHECK_YOUR_PLAN_STATE__PLAN = "predplatn\u00e9ho.";
export const CLOSE_WINDOW = "Zavri";
export const FILLOUT_BILLING_INFO_FIRST = "Ak potrebujete fakt\u00faru, vypl\u0148te si teraz pros\u00edm faktura\u010dn\u00e9 \u00fadaje.";
export const GET_PLUS_ALREADY_HAS = "U\u017e m\u00e1\u0161 PLUS aktivovan\u00e9.";
export const GET_PLUS_PAY_BY_BANK = "Zapla\u0165 na \u00fa\u010det";
export const GET_PLUS_PAY_BY_CARD = "Zapla\u0165 kartou";
export const GET_PLUS_PAY_BY_SMS = "Zapla\u0165 SMSkou";
export const GET_PLUS_PRICING_FOOTNOTE = "Automatick\u00e9 predl\u017eovanie predplatn\u00e9ho si m\u00f4\u017ee\u0161 kedyko\u013evek vypn\u00fa\u0165.";
export const GET_PRO_ALREADY_HAS = "U\u017e m\u00e1\u0161 PRO aktivovan\u00e9. ";
export const PLUS_PAYMENT_AMOUNT = "Suma:";
export const PLUS_PAYMENT_BANK_ACCOUNT = "\u010c\u00edslo \u00fa\u010dtu:";
export const PLUS_PAYMENT_BANK_ACCOUNT_NUMBER = "SK7111000000002920873508";
export const PLUS_PAYMENT_CUSTOMER_DATA = "Variabiln\u00fd symbol:";
export const PLUS_PAYMENT_WILL_BE_PROCESSED_IN_2_3_DAYS = "Platba bude spracovan\u00e1 po prip\u00edsan\u00ed na n\u00e1\u0161 \u00fa\u010det (t.j. 2-3 pracovn\u00e9 dni).";
export const PLUS_SEND_PAYMENT_TO_OUR_ACCOUNT = "Po\u0161li platbu na n\u00e1\u0161 \u00fa\u010det v Tatrabanke:";
export const VENDOR_DOWNLOAD_PAYMENT_PDF = "Stiahnite si podklad na \u00fahradu (PDF)";
